import React from "react";
import { CiUser } from "react-icons/ci";

const BlogDetailsHeading = ({ title, author, publishedDate }) => {
  const formattedDate = publishedDate
    ? new Date(publishedDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "N/A";

  return (
    <div className="w-full px-4 md:px-10 max-w-4xl">
      <div className="border-b-2 grid gap-4 pb-4">
        {/* Title */}
        <h1 className="font-bold text-2xl md:text-3xl text-gray-900 leading-snug">
          {title}
        </h1>

        {/* User info */}
        <div className="flex items-center gap-3 py-2">
          {/* User image
          <img
            src={ProfileImg}
            alt="Author"
            className="w-10 h-10 rounded-full object-cover"
          /> */}

          {/* Name + Date */}
          <div>
            <p className="text-gray-800 font-medium flex items-center gap-1">
              <CiUser /> {author}
            </p>
            <p className="text-sm text-gray-500">{formattedDate}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsHeading;
